import { text } from '#contract'
import { useView } from '../app/use-view.ts'
import { useT } from '../i18n/index.ts'
import styles from './fps-counter.module.css'

/** Smoothed frame rate, top right, only while the setting is on. */
export function FpsCounter() {
  const t = useT()
  const performance = useView((view) => view.performance)
  if (!performance) return null

  return <p class={styles.fps}>{t(text('hud.fps', { fps: performance.fps }))}</p>
}
